export const logisticSearchParam = 'logistic_id';
